// removed by extract-text-webpack-plugin
module.exports = {"login-container":"OptimaStripes_login-container---sb","loginContainer":"OptimaStripes_login-container---sb","top-line-color":"OptimaStripes_top-line-color---sb","topLineColor":"OptimaStripes_top-line-color---sb","stripe-list":"OptimaStripes_stripe-list---sb","stripeList":"OptimaStripes_stripe-list---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/OptimaStripes/styles.less
// module id = 1472
// module chunks = 0